import type { EChartsCoreOption } from "./echarts";

export const PRIVATE_CHART_TOOLTIP_CLASS = "oransim-private-chart-tooltip";

/** HTML tooltip 可挂到 body；统一标记并保留图表自身的 class 与配置。 */
export function withPrivateTooltips(option: EChartsCoreOption): EChartsCoreOption {
  const tag = (value: unknown) => {
    if (!value || typeof value !== "object" || Array.isArray(value)) return value;
    const tooltip = value;
    if ("renderMode" in tooltip && tooltip.renderMode === "richText") return tooltip;
    const className = "className" in tooltip && typeof tooltip.className === "string" ? tooltip.className : "";
    return { ...tooltip, className: `${className} ${PRIVATE_CHART_TOOLTIP_CLASS}`.trim() };
  };
  return { ...option, tooltip: Array.isArray(option.tooltip) ? option.tooltip.map(tag) : tag(option.tooltip) };
}

/** hideTip 有延迟；同步遮蔽现存 DOM，下一次已授权的正常 hover 会重新绘制其样式。 */
export function hidePrivateTooltips(): void {
  document.querySelectorAll<HTMLElement>(`.${PRIVATE_CHART_TOOLTIP_CLASS}`).forEach(element => {
    element.style.setProperty("display", "none", "important");
  });
}
